// 组件插槽
export const componentSlotsMap = {
  "rc-input": ["prefix", "suffix", "prepend", "append"],
  "rc-select": ["default", "prefix", "empty"],
  "rc-checkbox-group": ["default"],
  "rc-radio-group": ["default"],
  "rc-button": ["default"],
  "rc-radio": ["default"],
  "rc-checkbox": ["default"],
  "rc-cascader": ["default", "empty"],
  "rc-addon-title": ["default"]
};

// 查看类组件不进行编辑
export const componentViewList = ["rc-addon-title"];
